<template>
  <div class="meApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading"    @resize="handleResize">
    <div class="meCon">
      <div class="meheader">
        <div class="headMe">
          <img class="avatar" :src="userData.avatar" />
          <div class="right">
            <h2>{{userData.username}} </h2>
            <p v-if="rs.phone == ''">加入时间：{{userData.createtime}}</p>
            <p v-if="rs.phone != ''">手机号：{{rs.phone}}</p>
            <p @click="copy">邀请码：<input readonly="readonly" id="copy" v-model="rs.openid"><font style="font-size:12px;padding-left:5px">点击复制</font></p>
          </div>
          <div class="attend" @click="attend">{{rs.phone == '' ? '立即认证' : '您已认证'}}</div>

          <img v-if="rs.vip != 0" class="vip" src="~assets/images/vipimg.png"/>
        </div>

        <ul>
          <li @click="$router.push('garden')">
            <h3>{{rs.ryUser}}</h3>
            <div>进园次数</div>
          </li>
          <li @click="$router.push('mcoupon')">
            <h3>{{rs.coupon}}</h3>
            <div>优惠劵</div>
          </li>
          <li @click="$router.push('mwallet')">
            <h3>{{rs.wallet}}</h3>
            <div>去提现</div>
          </li>
          <li @click="$router.push('distribution')">
            <h3>{{rs.rose}}</h3>
            <div>我的分销</div>
          </li>
        </ul>
        <div class="recharge">
          <span>一锭“赚”银子</span>能玩、能收藏、能花、能赚！
          <a @click="$router.push('gatherorder')">一日游卡</a>
        </div>
      </div>

      <div class="orderAll">
        <h2>我的订单</h2>
        <ul>
          <li @click="order">
            <img src="~assets/images/menu_icon3.png"/>
            <span>景区订单</span>
          </li>
          <!--<li @click="$router.push('msorder')">
            <img src="~assets/images/movies.png"/>
            <span>电影订单</span>
          </li>-->
          <li @click="$router.push('porder')">
            <img src="~assets/images/gouwuche.png"/>
            <span>商圈订单</span>
          </li>
          <li @click="$router.push('lorder')">
            <img src="~assets/images/luggage.png"/>
            <span>行李订单</span>
          </li>
          <li @click="$router.push('lockYes')">
            <img src="~assets/images/cha.png"/>
            <span>茶室订单</span>
          </li>
        </ul>
      </div>

      <div class="meOrder">
        <div class="item-list" @click="$router.push('schedule')">
          <i class="el-icon-document left"></i>
          我的预约
          <i class="el-icon-arrow-right right"></i>
        </div>
        <div class="item-list" @click="$router.push('recharge')">
          <i class="el-icon-document left"></i>
          去充值
          <i class="el-icon-arrow-right right"></i>
        </div>
        <div class="item-list" v-if="rs.vip != 0">
          <i class="el-icon-time left"></i>
          VIP会员
          <i class="el-icon-arrow-right right"></i>
          <span>{{rs.vip}} 到期</span>
        </div>

        <div class="item-list" @click="$router.push('crowd')">
          <i class="el-icon-document left"></i>
          咖啡吧股东管理
          <i class="el-icon-arrow-right right"></i>
        </div>
        <!--<el-collapse accordion>
          <el-collapse-item>
            <template slot="title">
              <i class="el-icon-document left"></i>我的订单
            </template>
            <div @click="order"><i class="el-icon-arrow-right" style="color:#000;margin-right:10px;font-weight:bold"></i>景区订单<span>已购<font>{{rs.scenic}}</font>单</span></div>
            <div @click="$router.push('lockYes')"><i class="el-icon-arrow-right" style="color:#000;margin-right:10px;font-weight:bold"></i>茶室订单<span>已购<font>{{rs.lock}}</font>单</span></div>
            <div @click="$router.push('porder')"><i class="el-icon-arrow-right" style="color:#000;margin-right:10px;font-weight:bold"></i>商圈订单<span>已购<font>{{rs.mall}}</font>单</span></div>
            <div @click="$router.push('hall')"><i class="el-icon-arrow-right" style="color:#000;margin-right:10px;font-weight:bold"></i>配送订单</div>
            <div @click="$router.push('msorder')"><i class="el-icon-arrow-right" style="color:#000;margin-right:10px;font-weight:bold"></i>电影订单</div>
          </el-collapse-item>
        </el-collapse>-->
        <div class="item-list" @click="$router.push('cash')">
          <i class="el-icon-folder left"></i>
          我的实体卡
          <i class="el-icon-arrow-right right"></i>
        </div>
        <div class="item-list" @click="$router.push('indy')">
          <i class="el-icon-user left"></i>
          个人信息
          <i class="el-icon-arrow-right right"></i>
        </div>
        <a class="item-list" href="tel:18177968850">
          <i class="el-icon-headset left"></i>
          联系客服
          <i class="el-icon-arrow-right right"></i>
        </a>
        <div class="item-list" @click="$router.push('follow')">
          <i class="el-icon-folder-add left"></i>
          关注有礼
          <i class="el-icon-arrow-right right"></i>
        </div>
        <div class="item-list" @click="jump(rs.s_id,'smanage')" v-if="rs.s_id > 0">
          <i class="el-icon-thumb left"></i>
          景区管理
          <i class="el-icon-arrow-right right"></i>
        </div>
        <div class="item-list" @click="jump(rs.phone,'manage')" v-if="rs.mall_id > 0">
          <i class="el-icon-thumb left"></i>
          商家管理
          <i class="el-icon-arrow-right right"></i>
        </div>
        <div class="item-list" @click="jump(rs.lock_id,'owner')" v-if="rs.lock_id > 0">
          <i class="el-icon-thumb left"></i>
          共享空间管理
          <i class="el-icon-arrow-right right"></i>
        </div>

        <div class="item-list" @click="$router.push('clearer')" v-if="rs.clearer > 0">
          <i class="el-icon-thumb left"></i>
          清洁工管理
          <i class="el-icon-arrow-right right"></i>
          <span>{{rs.ctotal}}单待处理</span>
        </div>
        <div class="item-list" @click="$router.push('gathermanage')">
          <i class="el-icon-thumb left"></i>
          游卡管理
          <i class="el-icon-arrow-right right"></i>
        </div>
      </div>
    </div>
    <div :style="bool == 1 ? 'height:85px' :'height:65px'"></div>
    <footComponent :idx='4' :dx='bool'></footComponent>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        userData:[],
        curHeight:0,
        fullscreenLoading: false,
        rs:'',
        total:0,
        code:'',
        s_id:0,
        phone:'',
        isIphone:false,
        bool:0
      };
    },
    beforeMount() {
      window.removeEventListener("resize", this.handleResize);
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
      this.beforeMount();
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/mine');
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
          this.login();
        }
      }
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    mounted() {
      this.beforeMount();
      window.addEventListener("resize", this.handleResize);
      this.attestUser()
    },

    methods: {
      jump:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
        this.bool = (h >= 800 && this.isPhone() ? 1 : 0);
      },
      handleResize:function(e){
        if(this.curHeight < e.currentTarget.innerHeight && this.isPhone()){
          this.bool = 1;
        }else {
          if(this.curHeight >= 800 && this.curHeight == e.currentTarget.innerHeight && this.isPhone()){
            this.bool = 1;
          }else{
            this.bool = 0;
          }
        }
      },
      isPhone:function(){
        if (typeof window !== 'undefined' && window) {
            return /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812;
        }
        return false;
      },
      order:function(){
        window.location.href= this.$url + "/main/scenicOrder?id=1"
      },
      attend:function(){
        window.location.href = this.$url + "/main/attest"
      },

      attestUser:function(){
        var that = this;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/user/mine',
          params:{
            //user_id:9
            user_id:that.userData.id
          }
        }).then(function(response){
          var res = response.data.data;
          that.rs = res.phone;
          that.fullscreenLoading = false;
        }).catch(err=>{
          that.fullscreenLoading = false
        });
      },
      copy:function(){
        var Url2=document.querySelector("#copy");
        Url2.select(); // 选择对象
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$alert('复制成功！', '提示', {
          confirmButtonText: '确定'
        });
      },

      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          that.userData = res.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
      
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:80%
  }
  .meApp{
    max-width:640px;
    background:#ececec;
    margin:0 auto;
    position:relative;
  }
  .meApp .meheader{
    background: linear-gradient(90deg, #61BEFF, #4F7CFF);
    position: relative;
    height:200px
  }
  .meApp .headMe{
    width:92%;
    margin:0 auto;
    padding:15px 0;
  }
  .meApp .headMe:after,.meApp ul:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .meApp .headMe .avatar{
    width:60px;
    border-radius:100%;
    float:left;
  }
  .meApp .headMe .right{
    float:left;
    width:75%;
    margin-left:3%;
  }
  .meApp .headMe .right h2{
    font-size:17px;
    color:#fff
  }
  .meApp .headMe .right p input{
    font-weight:normal;
    font-size:12px;
    color:#f00;
    border:none;
    width:65px;
    background:none;
    outline:none;
    font-weight:500
  }
  .meApp .headMe .right p{
    font-size:14px;
    color:#fff;
    padding-top:1px
  }
  .meApp .headMe .attend{
    position:absolute;
    right:0;
    top:30px;
    background:#61BEFF;
    font-size:15px;
    color:#fff;
    border-radius:50px 0 0 50px;
    width:90px;
    height:35px;
    line-height:35px;
    text-align:center
  }
  .meApp .headMe .vip{
    position:absolute;
    left:58px;
    top:15px;
    width:20px;
  }
  .meApp .meheader ul{
    clear:both;
    padding:0px 0 20px 0;
    width:100%
  }
  .meApp .meheader ul li{
    float:left;
    width:25%;
    position:relative;
  }
  .meApp .meheader ul li:after{
    position:absolute;
    content:'';
    width:1px;
    height:30px;
    background:#61BEFF;
    right:0;
    top:50%;
    transform: translateY(-50%);
  }
  .meApp .meheader ul li:last-child:after{
    background:#4F7CFF;
  }
  .meApp .meheader ul li h3{
    text-align:center;
    font-size:18px;
    color:#fff
  }
  .meApp .meheader ul li div{
    text-align:center;
    font-size:13px;
    color:#666;
    padding-top:3px;
    color:#fff
  }


  .meApp .meheader .recharge{
    height:50px;
    background:rgba(0,0,0,.5);
    position: absolute;
    bottom:0px;
    width:96%;
    left:2%;
    border-radius: 15px 15px 0 0;
    line-height:50px;
    color:rgb(255,218,83);
    font-size:12px
  }
  .meApp .meheader .recharge span{
    font-size:16px;
    font-weight:bold;
    padding:0 6px 0 12px;
  }
  .meApp .meheader .recharge a{
    float:right;
    background:rgb(255,218,83);
    color:#000;
    height:30px;
    line-height:30px;
    width:75px;
    text-align:center;
    font-size:14px;
    border-radius: 30px;
    margin:10px 3% 0 0
  }


  .meApp .meCon{
    display:block;
    width:100%;
    margin:0 auto;
  }
  .meApp .meCon .meMoney{
    background:#fff;
    width:100%;
    display: flex;
  }
  .meApp .meCon .meMoney .item-me{
    flex: 1;
    width:20%;
    text-align:center
  }
  .meApp .meCon .meMoney .item-me span{
    display:block;
    font-weight:bold;
    font-size:18px;
    color:#000;
    height:17px;
  }
  .meApp .meCon .meMoney .item-me font{
    display:block;
    font-size:14px;
    font-weight:bold;
    color:#7a7a7a;
    padding-top:5px;
    width:100%
  }
  .meApp .meCon .meMoney .item-me img{
    width:17px;
    margin-top:1px;
    border:0;
  }
  .meApp .meCon .meOrder{
    background:#fff;
    width:96%;
    margin:0 auto;
    border-radius: 6px;
  }
  .meApp .meCon .meOrder .item-list{
    width:100%;
    font-size:15px;
    height:50px;
    line-height:50px;
    border-bottom:solid 1px #ececec;
    display:block;
    color:#333;
    font-weight:500;
    text-decoration: none;
  }
  .meApp .meCon .meOrder .left{
    float:left;
    font-size:18px;
    height:50px;
    line-height:50px;
    font-weight:bold;
    margin:0 8px 0 4%
  }
  .meApp .meCon .meOrder .right{
    float:right;
    font-size:15px;
    height:50px;
    line-height:50px;
    margin-right:2%
  }
  .meApp .meCon .meOrder .el-collapse{
    border:none
  }
  .meApp .meCon .meOrder .el-collapse-item__header{
    height:60px;
    line-height:60px;
    font-size:15px;
    color:#333
  }
  .meApp .meCon .meOrder .el-collapse-item__content{
    padding:0;
    font-size:15px;
    color:#000
  }
  .meApp .meCon .meOrder .el-collapse-item__content div{
    margin-left:4%;
    padding:15px 0;
    border-top:1px solid #ececec
  }
  .meApp .meCon .meOrder .el-collapse-item__content div:first-child{
    margin-left:0%;
    padding-left:4%;
  }
  .meApp .meCon .meOrder .el-collapse-item__content div span{
    float:right;
    margin-right:4%;
    color:#999;
    font-size:12px
  }
  .meApp .meCon .meOrder .el-collapse-item__content div span font{
    color:#f00;
    font-weight:bold;
    font-size:15px;
    padding:0 1px
  }
  .meApp .meCon .meOrder .item-list span{
    float:right;
    color:#666
  }

  .meApp .meCon .orderAll{
    width: 96%;
    margin: 12px auto;
    background: #fff;
    border-radius: 6px;
  }
  .meApp .meCon .orderAll h2{
    width: 92%;
    padding:12px 0 5px 0;
    margin: 0 auto;
    font-weight: bold;
    font-size:16px;
  }
  .meApp .meCon .orderAll ul{
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    width: 100%;
    margin: 0 auto;
    padding: 12px 0;
  }
  .meApp .meCon .orderAll ul li{
    width:25%
  }
  .meApp .meCon .orderAll ul li img{
    display: block;
    width: 30px;
    height: 30px;
    margin: 0 auto;
  }
  .meApp .meCon .orderAll ul li span{
    display: block;
    text-align: center;
    color: #666;
    font-size: 13px;
    padding-top: 2px;
  }
</style>